import { ReactComponent as CalendarButtonIcon } from "feather-icons/dist/icons/calendar.svg";
import { ReactComponent as NewIcon } from "feather-icons/dist/icons/plus-circle.svg";
import {
  AdminInformationContainer,
  Attention,
  SpondGroupContainer,
} from "./AdminSection.styled";
import { SvgDotPattern2 } from "../MembersDetailsContainer/MembersDetailsContainer.styled";
import {
  InformationContainerInner,
  Subheading,
} from "../SpondGroups/SpondGroups.styles";
import { ReactComponent as ListButtonIcon } from "feather-icons/dist/icons/list.svg";
import {
  Button,
  ButtonGroup,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverTrigger,
  useToast,
} from "@chakra-ui/react";
import { GetMailingList } from "api/secureApi.ts";
import React, { useState } from "react";
import { GetCookie } from "api/jwt";
import { ReactComponent as DownloadButtonIcon } from "feather-icons/dist/icons/download.svg";
import { BeatLoader } from "react-spinners";
import { ReactComponent as ReportsButtonIcon } from "feather-icons/dist/icons/pie-chart.svg";
import { CopyIcon, CheckCircleIcon } from "@chakra-ui/icons";
import usePromoCode from "./hooks/usePromoCode";

const AdminSection = ({ memberDetails }) => {
  const [downloadingSeniors, setDownloadingSeniors] = useState(false);
  const [downloadingJuniors, setDownloadingJuniors] = useState(false);
  const [copied, setCopied] = useState(false);
  const toast = useToast();
  const initialFocusRef = React.useRef();
  const { isLoading, promoCode, generatePromoCode } = usePromoCode();

  const toMembershipDatabase = function () {
    window.location.href = "/membership-database";
  };

  const toReports = function () {
    window.location.href = "/reports";
  };

  const toEditSessions = function () {
    window.location.href = "/edit-sessions";
  };

  const downloadSeniorsMailingList = function () {
    const idToken = GetCookie("idToken");
    setDownloadingSeniors(true);
    GetMailingList(idToken, "SENIOR")
      .then(() => {
        setDownloadingSeniors(false);
      })
      .catch((error) => {
        setDownloadingSeniors(false);
        toast({
          title: "Something went wrong - try again!",
          status: "error",
          isClosable: true,
        });
      });
  };

  const downloadJuniorsMailingList = function () {
    const idToken = GetCookie("idToken");
    setDownloadingJuniors(true);
    GetMailingList(idToken, "JUNIOR")
      .then(() => {
        setDownloadingJuniors(false);
      })
      .catch((error) => {
        setDownloadingJuniors(false);
        toast({
          title: "Something went wrong - try again!",
          status: "error",
          isClosable: true,
        });
      });
  };

  return (
    <AdminInformationContainer>
      <SvgDotPattern2 />
      <InformationContainerInner></InformationContainerInner>
      <Subheading>Admin Section</Subheading>
      <Attention>
        &#9888; Personal data! Wider dissemination and downloads kept for longer
        than absolutely nessesary could be in breach of the Data Protection Act.
        Any lost, stolen or incorrectly disseminated data must be brought to the
        attention of the webmaster immediately - BAD TRI are under legal
        obligation to notify the ICO within 72 hours of any such incident.
      </Attention>

      <SpondGroupContainer>
        {memberDetails.isAdmin && (
          <>
            <Button
              marginRight={2}
              marginBottom={2}
              onClick={toMembershipDatabase}
              colorScheme="red"
              size={"lg"}
              leftIcon={<ListButtonIcon />}
            >
              MEMBERS
            </Button>

            <Popover
              initialFocusRef={initialFocusRef}
              closeOnBlur={false}
              placement="top"
            >
              <PopoverTrigger>
                <Button
                  marginRight={2}
                  marginBottom={2}
                  colorScheme="red"
                  size={"lg"}
                  leftIcon={<DownloadButtonIcon />}
                >
                  MEMBER EXPORT
                </Button>
              </PopoverTrigger>
              <PopoverContent
                color="white"
                bg="blue.800"
                borderColor="blue.800"
              >
                <PopoverHeader pt={4} fontWeight="bold" border="0">
                  Important
                </PopoverHeader>
                <PopoverArrow bg="blue.800" />
                <PopoverCloseButton />
                <PopoverBody>
                  You're about to export bulk personal data from the system. You
                  must delete these files after use.
                </PopoverBody>
                <PopoverFooter
                  border="0"
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  pb={4}
                >
                  <ButtonGroup size="sm">
                    <Button
                      onClick={() => {
                        downloadJuniorsMailingList();
                        setDownloadingJuniors(true);
                      }}
                      isLoading={downloadingJuniors}
                      spinner={<BeatLoader size={8} color="black" />}
                      leftIcon={<DownloadButtonIcon />}
                    >
                      JUNIORS
                    </Button>
                    <Button
                      onClick={() => {
                        downloadSeniorsMailingList();
                        setDownloadingSeniors(true);
                      }}
                      isLoading={downloadingSeniors}
                      spinner={<BeatLoader size={8} color="black" />}
                      leftIcon={<DownloadButtonIcon />}
                      ref={initialFocusRef}
                    >
                      SENIORS
                    </Button>
                  </ButtonGroup>
                </PopoverFooter>
              </PopoverContent>
            </Popover>
            <Button
              marginRight={2}
              marginBottom={2}
              onClick={toReports}
              colorScheme="red"
              size={"lg"}
              leftIcon={<ReportsButtonIcon />}
            >
              REPORTS
            </Button>
            <Popover
              initialFocusRef={initialFocusRef}
              closeOnBlur={false}
              placement="top"
            >
              <PopoverTrigger>
                <Button
                  isLoading={isLoading}
                  marginRight={2}
                  marginBottom={2}
                  colorScheme="red"
                  size={"lg"}
                  leftIcon={<NewIcon />}
                  onClick={() => {
                    generatePromoCode();
                  }}
                >
                  NEW PROMO CODE
                </Button>
              </PopoverTrigger>
              <PopoverContent
                color="white"
                bg="blue.800"
                borderColor="blue.800"
              >
                <PopoverHeader pt={4} fontWeight="bold" border="0">
                  {isLoading ? "Generating promo code" : "Promo Code Created!"}
                </PopoverHeader>
                <PopoverArrow bg="blue.800" />
                <PopoverCloseButton />
                <PopoverBody>
                  <InputGroup size="md">
                    <Input
                      contentEditable={false}
                      value={promoCode}
                      pr="4.5rem"
                      placeholder="Creating promo code..."
                    />
                    <InputRightElement width="4.5rem">
                      <Button
                        isLoading={isLoading}
                        marginEnd={2}
                        rightIcon={copied ? <CheckCircleIcon /> : <CopyIcon />}
                        size={"xs"}
                        onClick={() => {
                          navigator.clipboard
                            .writeText(promoCode)
                            .then(function () {
                              setCopied(true);
                              setTimeout(() => {
                                setCopied(false);
                              }, 800);
                            });
                        }}
                      >
                        {copied ? "Copied" : "Copy"}
                      </Button>
                    </InputRightElement>
                  </InputGroup>
                </PopoverBody>
              </PopoverContent>
            </Popover>
          </>
        )}
        <Button
          marginRight={2}
          marginBottom={2}
          onClick={toEditSessions}
          colorScheme="red"
          size={"lg"}
          leftIcon={<CalendarButtonIcon />}
        >
          EDIT SESSIONS
        </Button>
      </SpondGroupContainer>
    </AdminInformationContainer>
  );
};

export default AdminSection;
